import { useMemo, useState } from 'react';

import { TabComponent } from 'src/app/components/antd/TabComponent';

import { Container } from './styles';

export type TabsProductsProps = {
  optionsTabProducts: {
    label: string;
    component: React.ReactNode;
    disabled?: boolean;
  }[];
};

export function TabsProducts({ optionsTabProducts }: TabsProductsProps) {
  const [tabActive, setTabActive] = useState('0');

  const tabActiveComponent = useMemo(() => {
    return optionsTabProducts[Number(tabActive)]?.component || <></>;
  }, [tabActive, optionsTabProducts]);

  return (
    <Container>
      <TabComponent
        tabList={optionsTabProducts.map(({ label, disabled }) => ({
          title: label,
          disabled: !!disabled,
        }))}
        onChangeTab={setTabActive}
        defaultActiveKey={tabActive}
      />
      {tabActiveComponent}
    </Container>
  );
}
